import inflator from "./inflator"
export default inflator
